import { katTranslator } from '../../shared/i18n';

const strings = {
  'region-selector-placeholder': {
    'ar-AE': {
      param: '0',
      pluralItems: {
        zero: '{0,number,integer} لا توجد أي بلدان/مناطق',
        one: '{0,number,integer} بلد واحد/منطقة واحدة',
        two: '{0,number,integer} بلدتان/منطقتان',
        few: '{0,number,integer}بلدان/مناطق',
        many: '{0,number,integer} بلدان/مناطق',
        other: 'بلدان/مناطق {0,number,integer}',
      },
    },
    'bn-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} দেশ/অঞ্চল',
        other: '{0,number,integer} দেশ/অঞ্চল',
      },
    },
    'cs-CZ': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} země/oblast',
        few: '{0,number,integer} zemí/oblastí',
        many: '{0,number,integer} zemí/oblastí',
        other: '{0,number,integer} země/oblasti',
      },
    },
    'da-DK': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Land/region',
        other: '{0,number,integer} Lande/regioner',
      },
    },
    'de-DE': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Land/Region',
        other: '{0,number,integer} Länder/Regionen',
      },
    },
    'en-AE': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/Region',
        other: '{0,number,integer} Countries/Regions',
      },
    },
    'en-AU': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/Region',
        other: '{0,number,integer} Countries/Regions',
      },
    },
    'en-CA': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/Region',
        other: '{0,number,integer} Countries/Regions',
      },
    },
    'en-GB': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/Region',
        other: '{0,number,integer} Countries/Regions',
      },
    },
    'en-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/Region',
        other: '{0,number,integer}Countries/Regions',
      },
    },
    'en-NG': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/Region',
        other: '{0,number,integer} Countries/Regions',
      },
    },
    'en-SG': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/Region',
        other: '{0,number,integer} Countries/Regions',
      },
    },
    'en-US': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/Region',
        other: '{0,number,integer} Countries/Regions',
      },
    },
    'en-ZA': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Country/Region',
        other: '{0,number,integer} Countries/Regions',
      },
    },
    'es-CL': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} País/Región',
        other: '{0,number,integer} Países/Regiones',
        many: '{0,number,integer} Países/Regiones',
      },
    },
    'es-CO': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} país/región',
        other: '{0,number,integer} países/regiones',
        many: '{0,number,integer} de países/regiones',
      },
    },
    'es-ES': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} país/región',
        other: '{0,number,integer} países/regiones',
        many: '{0,number,integer} países/regiones',
      },
    },
    'es-MX': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} País/Región',
        other: '{0,number,integer} Países/Regiones',
        many: '{0,number,integer} Países/Regiones',
      },
    },
    'es-US': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} País/Región',
        other: '{0,number,integer} Países/Regiones',
        many: '{0,number,integer} Países/Regiones',
      },
    },
    'fr-BE': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} pays/région',
        other: '{0,number,integer} pays/régions',
        many: '{0,number,integer} de pays/régions',
      },
    },
    'fr-CA': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} pays/région',
        other: '{0,number,integer} pays/régions',
        many: '{0,number,integer} pays/régions',
      },
    },
    'fr-FR': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} pays/région',
        other: '{0,number,integer} pays/régions',
        many: '{0,number,integer} de pays/régions',
      },
    },
    'he-IL': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} מדינה/אזור',
        two: '{0,number,integer} מדינות/אזורים',
        other: '{0,number,integer} מדינות/אזורים',
        many: '{0,number,integer} מדינות/אזורים',
      },
    },
    'hi-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} देश/क्षेत्र',
        other: '{0,number,integer} देश/क्षेत्र',
      },
    },
    'it-IT': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Paese/territorio',
        many: '{0,number,integer} Paesi/territori',
        other: '{0,number,integer} Paesi/territori',
      },
    },
    'ja-JP': {
      param: '0',
      pluralItems: {
        other: '{0,number,integer}国/地域',
      },
    },
    'kn-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} ದೇಶ/ಪ್ರದೇಶ',
        other: '{0,number,integer} ದೇಶಗಳು/ಪ್ರದೇಶಗಳು',
      },
    },
    'ko-KR': {
      param: '0',
      pluralItems: {
        other: '{0,number,integer} 국가/지역',
      },
    },
    'ml-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} രാജ്യം/പ്രദേശം',
        other: '{0,number,integer}രാജ്യങ്ങൾ/പ്രദേശങ്ങൾ',
      },
    },
    'mr-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} देश/प्रदेश',
        other: '{0,number,integer} देश/प्रदेश',
      },
    },
    'nl-BE': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Land/Regio',
        other: "{0,number,integer} Landen/regio''s",
      },
    },
    'nl-NL': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Land / regio',
        other: "{0,number,integer} Landen / regio''s",
      },
    },
    'pl-PL': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Kraj/region',
        few: '{0,number,integer} Kraje/regiony',
        many: '{0,number,integer} Krajów/regiów',
        other: '{0,number,integer} Krajów/regionów',
      },
    },
    'pt-BR': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} país/região',
        other: '{0,number,integer} países/regiões',
        many: '{0,number,integer} de países/regiões',
      },
    },
    'pt-PT': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} País/região',
        other: '{0,number,integer} Países/regiões',
        many: '{0,number,integer} Países/regiões',
      },
    },
    'sv-SE': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} Land/region',
        other: '{0,number,integer} Länder/regioner',
      },
    },
    'ta-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} நாடு/பிராந்தியம்',
        other: '{0,number,integer} நாடுகள்/பிராந்தியங்கள்',
      },
    },
    'te-IN': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer}దేశం/ప్రాంతం',
        other: '{0,number,integer}దేశాలు/ప్రాంతాలు',
      },
    },
    'tr-TR': {
      param: '0',
      pluralItems: {
        one: '{0,number,integer} ülke/bölge.',
        other: '{0,number,integer} ülke/bölge.',
      },
    },
    'zh-CN': {
      param: '0',
      pluralItems: {
        other: '{0,number,integer} 个国家/地区',
      },
    },
    'zh-TW': {
      param: '0',
      pluralItems: {
        other: '{0,number,integer}國家/地區',
      },
    },
  },
  'region-selector-americas': {
    'ar-AE': 'الأمريكيتان',
    'bn-IN': 'আমেরিকা',
    'cs-CZ': 'Severní a Jižní Amerika',
    'da-DK': 'Amerika',
    'de-DE': 'Nord- und Südamerika',
    'en-AE': 'Americas',
    'en-AU': 'Americas',
    'en-CA': 'Americas',
    'en-GB': 'Americas',
    'en-IN': 'Americas',
    'en-NG': 'Americas',
    'en-SG': 'Americas',
    'en-US': 'Americas',
    'en-ZA': 'Americas',
    'es-CL': 'América',
    'es-CO': 'América',
    'es-ES': 'América',
    'es-MX': 'América',
    'es-US': 'América',
    'fr-BE': 'Amériques',
    'fr-CA': 'Amériques',
    'fr-FR': 'Amériques',
    'he-IL': 'מדינות אמריקה',
    'hi-IN': 'अमेरिका',
    'it-IT': 'Americhe',
    'ja-JP': '南北アメリカ',
    'kn-IN': 'ಅಮೆರಿಕಾಸ್',
    'ko-KR': '아메리카 대륙',
    'ml-IN': 'അമേരിക്ക',
    'mr-IN': 'अमेरिकाज',
    'nl-BE': 'Noord- en Zuid-Amerika',
    'nl-NL': 'Noord- en Zuid-Amerika',
    'pl-PL': 'Ameryki',
    'pt-BR': 'Américas',
    'pt-PT': 'América do Sul e América do Norte',
    'sv-SE': 'Nord- och Sydamerika',
    'ta-IN': 'அமெரிக்க நாடுகள்',
    'te-IN': 'అమెరికాస్',
    'tr-TR': 'Amerika Kıtası.',
    'zh-CN': '美洲',
    'zh-TW': '美洲',
  },
  'region-selector-brazil': {
    'ar-AE': 'البرازيل',
    'bn-IN': 'ব্রাজিল',
    'cs-CZ': 'Brazílie',
    'da-DK': 'Brasilien',
    'de-DE': 'Brasilien',
    'en-AE': 'Brazil',
    'en-AU': 'Brazil',
    'en-CA': 'Brazil',
    'en-GB': 'Brazil',
    'en-IN': 'Brazil',
    'en-NG': 'Brazil',
    'en-SG': 'Brazil',
    'en-US': 'Brazil',
    'en-ZA': 'Brazil',
    'es-CL': 'Brasil',
    'es-CO': 'Brasil',
    'es-ES': 'Brasil',
    'es-MX': 'Brasil',
    'es-US': 'Brasil',
    'fr-BE': 'Brésil',
    'fr-CA': 'Brésil',
    'fr-FR': 'Brésil',
    'he-IL': 'ברזיל',
    'hi-IN': 'ब्राज़ील',
    'it-IT': 'Brasile',
    'ja-JP': 'ブラジル',
    'kn-IN': 'ಬ್ರೆಜಿಲ್',
    'ko-KR': '브라질',
    'ml-IN': 'ബ്രസീൽ',
    'mr-IN': 'ब्राझिल',
    'nl-BE': 'Brazilië',
    'nl-NL': 'Brazilië',
    'pl-PL': 'Brazylia',
    'pt-BR': 'Brasil',
    'pt-PT': 'Brasil',
    'sv-SE': 'Brasilien',
    'ta-IN': 'பிரேசில்',
    'te-IN': 'బ్రెజిల్',
    'tr-TR': 'Brezilya.',
    'zh-CN': '巴西',
    'zh-TW': '巴西',
  },
  'region-selector-canada': {
    'ar-AE': 'كندا',
    'bn-IN': 'কানাডা',
    'cs-CZ': 'Kanada',
    'da-DK': 'Canada',
    'de-DE': 'Kanada',
    'en-AE': 'Canada',
    'en-AU': 'Canada',
    'en-CA': 'Canada',
    'en-GB': 'Canada',
    'en-IN': 'Canada',
    'en-NG': 'Canada',
    'en-SG': 'Canada',
    'en-US': 'Canada',
    'en-ZA': 'Canada',
    'es-CL': 'Canadá',
    'es-CO': 'Canadá',
    'es-ES': 'Canadá',
    'es-MX': 'Canadá',
    'es-US': 'Canadá',
    'fr-BE': 'Canada',
    'fr-CA': 'Canada',
    'fr-FR': 'Canada',
    'he-IL': 'קנדה',
    'hi-IN': 'कनाडा',
    'it-IT': 'Canada',
    'ja-JP': 'カナダ',
    'kn-IN': 'ಕೆನಡಾ',
    'ko-KR': '캐나다',
    'ml-IN': 'കാനഡ',
    'mr-IN': 'कॅनडा',
    'nl-BE': 'Canada',
    'nl-NL': 'Canada',
    'pl-PL': 'Kanada',
    'pt-BR': 'Canadá',
    'pt-PT': 'Canadá',
    'sv-SE': 'Kanada',
    'ta-IN': 'கனடா',
    'te-IN': 'కెనడా',
    'tr-TR': 'Kanada.',
    'zh-CN': '加拿大',
    'zh-TW': '加拿大',
  },
  'region-selector-united-states': {
    'ar-AE': 'الولايات المتحدة',
    'bn-IN': 'মার্কিন যুক্তরাষ্ট্র',
    'cs-CZ': 'Spojené státy',
    'da-DK': 'USA',
    'de-DE': 'USA',
    'en-AE': 'United States',
    'en-AU': 'United States',
    'en-CA': 'United States',
    'en-GB': 'United States',
    'en-IN': 'United States',
    'en-NG': 'United States',
    'en-SG': 'United States',
    'en-US': 'United States',
    'en-ZA': 'United States',
    'es-CL': 'Estados Unidos',
    'es-CO': 'Estados Unidos',
    'es-ES': 'Estados Unidos',
    'es-MX': 'Estados Unidos',
    'es-US': 'Estados Unidos',
    'fr-BE': 'États-Unis',
    'fr-CA': 'États-Unis',
    'fr-FR': 'États-Unis',
    'he-IL': 'ארצות הברית',
    'hi-IN': 'संयुक्त राज्य अमेरिका',
    'it-IT': 'Stati Uniti',
    'ja-JP': '米国',
    'kn-IN': 'ಯುನೈಟೆಡ್ ಸ್ಟೇಟ್ಸ್',
    'ko-KR': '미국',
    'ml-IN': 'യുണൈറ്റഡ് സ്റ്റേറ്റ്സ്',
    'mr-IN': 'युनायटेड स्टेट्स',
    'nl-BE': 'Verenigde Staten',
    'nl-NL': 'Verenigde Staten',
    'pl-PL': 'Stany Zjednoczone',
    'pt-BR': 'Estados Unidos',
    'pt-PT': 'Estados Unidos',
    'sv-SE': 'USA',
    'ta-IN': 'ஐக்கிய அமெரிக்கா',
    'te-IN': 'యునైటెడ్ స్టేట్స్',
    'tr-TR': 'Amerika Birleşik Devletleri.',
    'zh-CN': '美国',
    'zh-TW': '美國',
  },
  'region-selector-mexico': {
    'ar-AE': 'المكسيك',
    'bn-IN': 'মেক্সিকো',
    'cs-CZ': 'Mexiko',
    'da-DK': 'Mexico',
    'de-DE': 'Mexiko',
    'en-AE': 'Mexico',
    'en-AU': 'Mexico',
    'en-CA': 'Mexico',
    'en-GB': 'Mexico',
    'en-IN': 'Mexico',
    'en-NG': 'Mexico',
    'en-SG': 'Mexico',
    'en-US': 'Mexico',
    'en-ZA': 'Mexico',
    'es-CL': 'México',
    'es-CO': 'México',
    'es-ES': 'México',
    'es-MX': 'México',
    'es-US': 'México',
    'fr-BE': 'Mexique',
    'fr-CA': 'Mexique',
    'fr-FR': 'Mexique',
    'he-IL': 'מקסיקו',
    'hi-IN': 'मेक्सिको',
    'it-IT': 'Messico',
    'ja-JP': 'メキシコ',
    'kn-IN': 'ಮೆಕ್ಸಿಕೊ',
    'ko-KR': '멕시코',
    'ml-IN': 'മെക്സിക്കോ',
    'mr-IN': 'मेक्सिको',
    'nl-BE': 'Mexico',
    'nl-NL': 'Mexico',
    'pl-PL': 'Meksyk',
    'pt-BR': 'México',
    'pt-PT': 'México',
    'sv-SE': 'Mexiko',
    'ta-IN': 'மெக்ஸிகோ',
    'te-IN': 'మెక్సికో',
    'tr-TR': 'Meksika.',
    'zh-CN': '墨西哥',
    'zh-TW': '墨西哥',
  },
  'region-selector-asia-pacific': {
    'ar-AE': 'آسيا - المحيط الهادئ',
    'bn-IN': 'এশিয়া-প্যাসিফিক',
    'cs-CZ': 'Asie a Tichomoří',
    'da-DK': 'Asien-Stillehavet',
    'de-DE': 'Asien-Pazifik',
    'en-AE': 'Asia-Pacific',
    'en-AU': 'Asia-Pacific',
    'en-CA': 'Asia-Pacific',
    'en-GB': 'Asia-Pacific',
    'en-IN': 'Asia-Pacific',
    'en-NG': 'Asia-Pacific',
    'en-SG': 'Asia-Pacific',
    'en-US': 'Asia-pacific',
    'en-ZA': 'Asia-Pacific',
    'es-CL': 'Asia-Pacífico',
    'es-CO': 'Asia-Pacífico',
    'es-ES': 'Asia Pacífico',
    'es-MX': 'Asia y Pacífico',
    'es-US': 'Asia-Pacífico',
    'fr-BE': 'Asie-Pacifique',
    'fr-CA': 'Asie-Pacifique',
    'fr-FR': 'Asie-Pacifique',
    'he-IL': 'אסיה-פסיפיק',
    'hi-IN': 'एशिया-प्रशांत',
    'it-IT': 'Asia-Pacifico',
    'ja-JP': 'アジア太平洋',
    'kn-IN': 'ಏಷ್ಯಾ-ಪೆಸಿಫಿಕ್',
    'ko-KR': '아시아-태평양',
    'ml-IN': 'ഏഷ്യ-പസിഫിക്ക്',
    'mr-IN': 'आशिया-पॅसिफिक',
    'nl-BE': 'Aziatisch-Pacifisch',
    'nl-NL': 'Aziatisch-Pacifisch',
    'pl-PL': 'Azja i Pacyfik',
    'pt-BR': 'Ásia-Pacífico',
    'pt-PT': 'Ásia-Pacífico',
    'sv-SE': 'Asien-Stilla havsområdet',
    'ta-IN': 'ஆசிய பசிஃபிக் நாடுகள்',
    'te-IN': 'ఆసియా-పసిఫిక్',
    'tr-TR': 'Asya-Pasifik.',
    'zh-CN': '亚太地区',
    'zh-TW': '亞太地區',
  },
  'region-selector-australia': {
    'ar-AE': 'أستراليا',
    'bn-IN': 'অস্ট্রেলিয়া',
    'cs-CZ': 'Austrálie',
    'da-DK': 'Australien',
    'de-DE': 'Australien',
    'en-AE': 'Australia',
    'en-AU': 'Australia',
    'en-CA': 'Australia',
    'en-GB': 'Australia',
    'en-IN': 'Australia',
    'en-NG': 'Australia',
    'en-SG': 'Australia',
    'en-US': 'Australia',
    'en-ZA': 'Australia',
    'es-CL': 'Australia',
    'es-CO': 'Australia',
    'es-ES': 'Australia',
    'es-MX': 'Australia',
    'es-US': 'Australia',
    'fr-BE': 'Australie',
    'fr-CA': 'Australie',
    'fr-FR': 'Australie',
    'he-IL': 'אוסטרליה',
    'hi-IN': 'ऑस्ट्रेलिया',
    'it-IT': 'Australia',
    'ja-JP': 'オーストラリア',
    'kn-IN': 'ಆಸ್ಟ್ರೇಲಿಯಾ',
    'ko-KR': '호주',
    'ml-IN': 'ഓസ്‌ട്രേലിയ',
    'mr-IN': 'ऑस्ट्रेलिया',
    'nl-BE': 'Australië',
    'nl-NL': 'Australië',
    'pl-PL': 'Australia',
    'pt-BR': 'Austrália',
    'pt-PT': 'Austrália',
    'sv-SE': 'Australien',
    'ta-IN': 'ஆஸ்திரேலியா',
    'te-IN': 'ఆస్ట్రేలియా',
    'tr-TR': 'Avustralya.',
    'zh-CN': '澳大利亚',
    'zh-TW': '澳洲',
  },
  'region-selector-india': {
    'ar-AE': 'الهند',
    'bn-IN': 'ভারত',
    'cs-CZ': 'Indie',
    'da-DK': 'Indien',
    'de-DE': 'Indien',
    'en-AE': 'India',
    'en-AU': 'India',
    'en-CA': 'India',
    'en-GB': 'India',
    'en-IN': 'India',
    'en-NG': 'India',
    'en-SG': 'India',
    'en-US': 'India',
    'en-ZA': 'India',
    'es-CL': 'India',
    'es-CO': 'India',
    'es-ES': 'India',
    'es-MX': 'India',
    'es-US': 'India',
    'fr-BE': 'Inde',
    'fr-CA': 'Inde',
    'fr-FR': 'Inde',
    'he-IL': 'הודו',
    'hi-IN': 'भारत',
    'it-IT': 'India',
    'ja-JP': 'インド',
    'kn-IN': 'ಭಾರತ',
    'ko-KR': '인도',
    'ml-IN': 'ഇന്ത്യ',
    'mr-IN': 'भारत',
    'nl-BE': 'India',
    'nl-NL': 'India',
    'pl-PL': 'Indie',
    'pt-BR': 'Índia',
    'pt-PT': 'Índia',
    'sv-SE': 'Indien',
    'ta-IN': 'இந்தியா',
    'te-IN': 'భారత దేశం',
    'tr-TR': 'Hindistan.',
    'zh-CN': '印度',
    'zh-TW': '印度',
  },
  'region-selector-japan': {
    'ar-AE': 'اليابان',
    'bn-IN': 'জাপান',
    'cs-CZ': 'Japonsko',
    'da-DK': 'Japan',
    'de-DE': 'Japan',
    'en-AE': 'Japan',
    'en-AU': 'Japan',
    'en-CA': 'Japan',
    'en-GB': 'Japan',
    'en-IN': 'Japan',
    'en-NG': 'Japan',
    'en-SG': 'Japan',
    'en-US': 'Japan',
    'en-ZA': 'Japan',
    'es-CL': 'Japón',
    'es-CO': 'Japón',
    'es-ES': 'Japón',
    'es-MX': 'Japón',
    'es-US': 'Japón',
    'fr-BE': 'Japon',
    'fr-CA': 'Japon',
    'fr-FR': 'Japon',
    'he-IL': 'יפן',
    'hi-IN': 'जापान',
    'it-IT': 'Giappone',
    'ja-JP': '日本',
    'kn-IN': 'ಜಪಾನ್',
    'ko-KR': '일본',
    'ml-IN': 'ജപ്പാൻ',
    'mr-IN': 'जपान',
    'nl-BE': 'Japan',
    'nl-NL': 'Japan',
    'pl-PL': 'Japonia',
    'pt-BR': 'Japão',
    'pt-PT': 'Japão',
    'sv-SE': 'Japan',
    'ta-IN': 'ஜப்பான்',
    'te-IN': 'జపాన్',
    'tr-TR': 'Japonya.',
    'zh-CN': '日本',
    'zh-TW': '日本',
  },
  'region-selector-singapore': {
    'ar-AE': 'سنغافورة',
    'bn-IN': 'সিঙ্গাপুর',
    'cs-CZ': 'Singapur',
    'da-DK': 'Singapore',
    'de-DE': 'Singapur',
    'en-AE': 'Singapore',
    'en-AU': 'Singapore',
    'en-CA': 'Singapore',
    'en-GB': 'Singapore',
    'en-IN': 'Singapore',
    'en-NG': 'Singapore',
    'en-SG': 'Singapore',
    'en-US': 'Singapore',
    'en-ZA': 'Singapore',
    'es-CL': 'Singapur',
    'es-CO': 'Singapur',
    'es-ES': 'Singapur',
    'es-MX': 'Singapur',
    'es-US': 'Singapur',
    'fr-BE': 'Singapour',
    'fr-CA': 'Singapour',
    'fr-FR': 'Singapour',
    'he-IL': 'סינגפור',
    'hi-IN': 'सिंगापुर',
    'it-IT': 'Singapore',
    'ja-JP': 'シンガポール',
    'kn-IN': 'ಸಿಂಗಾಪುರ',
    'ko-KR': '싱가포르',
    'ml-IN': 'സിംഗപ്പൂർ',
    'mr-IN': 'सिंगापूर',
    'nl-BE': 'Singapore',
    'nl-NL': 'Singapore',
    'pl-PL': 'Singapur',
    'pt-BR': 'Singapura',
    'pt-PT': 'Singapura',
    'sv-SE': 'Singapore',
    'ta-IN': 'சிங்கப்பூர்',
    'te-IN': 'సింగపూర్',
    'tr-TR': 'Singapur.',
    'zh-CN': '新加坡',
    'zh-TW': '新加坡',
  },
  'region-selector-europe': {
    'ar-AE': 'أوروبا',
    'bn-IN': 'ইউরোপ',
    'cs-CZ': 'Evropa',
    'da-DK': 'Europa',
    'de-DE': 'Europa',
    'en-AE': 'Europe',
    'en-AU': 'Europe',
    'en-CA': 'Europe',
    'en-GB': 'Europe',
    'en-IN': 'Europe',
    'en-NG': 'Europe',
    'en-SG': 'Europe',
    'en-US': 'Europe',
    'en-ZA': 'Europe',
    'es-CL': 'Europa',
    'es-CO': 'Europa',
    'es-ES': 'Europa',
    'es-MX': 'Europa',
    'es-US': 'Europa',
    'fr-BE': 'Europe',
    'fr-CA': 'Europe',
    'fr-FR': 'Europe',
    'he-IL': 'אירופה',
    'hi-IN': 'यूरोप',
    'it-IT': 'Europa',
    'ja-JP': 'ヨーロッパ',
    'kn-IN': 'ಯೂರೋಪ್',
    'ko-KR': '유럽',
    'ml-IN': 'യൂറോപ്പ്',
    'mr-IN': 'युरोप',
    'nl-BE': 'Europa',
    'nl-NL': 'Europa',
    'pl-PL': 'Europa',
    'pt-BR': 'Europa',
    'pt-PT': 'Europa',
    'sv-SE': 'Europa',
    'ta-IN': 'ஐரோப்பா',
    'te-IN': 'యూరోప్',
    'tr-TR': 'Avrupa.',
    'zh-CN': '欧洲',
    'zh-TW': '歐洲',
  },
  'region-selector-belgium': {
    'ar-AE': 'بلجيكا',
    'bn-IN': 'বেলজিয়াম',
    'cs-CZ': 'Belgie',
    'da-DK': 'Belgien',
    'de-DE': 'Belgien',
    'en-AE': 'Belgium',
    'en-AU': 'Belgium',
    'en-CA': 'Belgium',
    'en-GB': 'Belgium',
    'en-IN': 'Belgium',
    'en-NG': 'Belgium',
    'en-SG': 'Belgium',
    'en-US': 'Belgium',
    'en-ZA': 'Belgium',
    'es-CL': 'Bélgica',
    'es-CO': 'Bélgica',
    'es-ES': 'Bélgica',
    'es-MX': 'Bélgica',
    'es-US': 'Bélgica',
    'fr-BE': 'Belgique',
    'fr-CA': 'Belgique',
    'fr-FR': 'Belgique',
    'he-IL': 'בלגיה',
    'hi-IN': 'बेल्जियम',
    'it-IT': 'Belgio',
    'ja-JP': 'ベルギー',
    'kn-IN': 'ಬೆಲ್ಜಿಯಂ',
    'ko-KR': '벨기에',
    'ml-IN': 'ബെൽജിയം',
    'mr-IN': 'बेल्जियम',
    'nl-BE': 'België',
    'nl-NL': 'België',
    'pl-PL': 'Belgia',
    'pt-BR': 'Bélgica',
    'pt-PT': 'Bélgica',
    'sv-SE': 'Belgien',
    'ta-IN': 'பெல்ஜியம்',
    'te-IN': 'బెల్జియం',
    'tr-TR': 'Belçika.',
    'zh-CN': '比利时',
    'zh-TW': '比利時',
  },
  'region-selector-france': {
    'ar-AE': 'فرنسا',
    'bn-IN': 'ফ্রান্স',
    'cs-CZ': 'Francie',
    'da-DK': 'Frankrig',
    'de-DE': 'Frankreich',
    'en-AE': 'France',
    'en-AU': 'France',
    'en-CA': 'France',
    'en-GB': 'France',
    'en-IN': 'France',
    'en-NG': 'France',
    'en-SG': 'France',
    'en-US': 'France',
    'en-ZA': 'France',
    'es-CL': 'Francia',
    'es-CO': 'Francia',
    'es-ES': 'Francia',
    'es-MX': 'Francia',
    'es-US': 'Francia',
    'fr-BE': 'France',
    'fr-CA': 'France',
    'fr-FR': 'France',
    'he-IL': 'צרפת',
    'hi-IN': 'फ़्रांस',
    'it-IT': 'Francia',
    'ja-JP': 'フランス',
    'kn-IN': 'ಫ್ರಾನ್ಸ್',
    'ko-KR': '프랑스',
    'ml-IN': 'ഫ്രാൻസ്',
    'mr-IN': 'फ्रान्स',
    'nl-BE': 'Frankrijk',
    'nl-NL': 'Frankrijk',
    'pl-PL': 'Francja',
    'pt-BR': 'França',
    'pt-PT': 'França',
    'sv-SE': 'Frankrike',
    'ta-IN': 'பிரான்ஸ்',
    'te-IN': 'ఫ్రాన్స్',
    'tr-TR': 'Fransa.',
    'zh-CN': '法国',
    'zh-TW': '法國',
  },
  'region-selector-germany': {
    'ar-AE': 'ألمانيا',
    'bn-IN': 'জার্মানি',
    'cs-CZ': 'Německo',
    'da-DK': 'Tyskland',
    'de-DE': 'Deutschland',
    'en-AE': 'Germany',
    'en-AU': 'Germany',
    'en-CA': 'Germany',
    'en-GB': 'Germany',
    'en-IN': 'Germany',
    'en-NG': 'Germany',
    'en-SG': 'Germany',
    'en-US': 'Germany',
    'en-ZA': 'Germany',
    'es-CL': 'Alemania',
    'es-CO': 'Alemania',
    'es-ES': 'Alemania',
    'es-MX': 'Alemania',
    'es-US': 'Alemania',
    'fr-BE': 'Allemagne',
    'fr-CA': 'Allemagne',
    'fr-FR': 'Allemagne',
    'he-IL': 'גרמניה',
    'hi-IN': 'जर्मनी',
    'it-IT': 'Germania',
    'ja-JP': 'ドイツ',
    'kn-IN': 'ಜರ್ಮನಿ',
    'ko-KR': '독일',
    'ml-IN': 'ജർമ്മനി',
    'mr-IN': 'जर्मनी',
    'nl-BE': 'Duitsland',
    'nl-NL': 'Duitsland',
    'pl-PL': 'Niemcy',
    'pt-BR': 'Alemanha',
    'pt-PT': 'Alemanha',
    'sv-SE': 'Tyskland',
    'ta-IN': 'ஜெர்மனி',
    'te-IN': 'జర్మనీ',
    'tr-TR': 'Almanya.',
    'zh-CN': '德国',
    'zh-TW': '德國',
  },
  'region-selector-italy': {
    'ar-AE': 'إيطاليا',
    'bn-IN': 'ইতালি',
    'cs-CZ': 'Itálie',
    'da-DK': 'Italien',
    'de-DE': 'Italien',
    'en-AE': 'Italy',
    'en-AU': 'Italy',
    'en-CA': 'Italy',
    'en-GB': 'Italy',
    'en-IN': 'Italy',
    'en-NG': 'Italy',
    'en-SG': 'Italy',
    'en-US': 'Italy',
    'en-ZA': 'Italy',
    'es-CL': 'Italia',
    'es-CO': 'Italia',
    'es-ES': 'Italia',
    'es-MX': 'Italia',
    'es-US': 'Italia',
    'fr-BE': 'Italie',
    'fr-CA': 'Italie',
    'fr-FR': 'Italie',
    'he-IL': 'איטליה',
    'hi-IN': 'इटली',
    'it-IT': 'Italia',
    'ja-JP': 'イタリア',
    'kn-IN': 'ಇಟಲಿ',
    'ko-KR': '이탈리아',
    'ml-IN': 'ഇറ്റലി',
    'mr-IN': 'इटली',
    'nl-BE': 'Italië',
    'nl-NL': 'Italië',
    'pl-PL': 'Włochy',
    'pt-BR': 'Itália',
    'pt-PT': 'Itália',
    'sv-SE': 'Italien',
    'ta-IN': 'இத்தாலி',
    'te-IN': 'ఇటలీ',
    'tr-TR': 'İtalya.',
    'zh-CN': '意大利',
    'zh-TW': '義大利',
  },
  'region-selector-netherlands': {
    'ar-AE': 'هولندا',
    'bn-IN': 'নেদারল্যান্ডস',
    'cs-CZ': 'Nizozemsko',
    'da-DK': 'Holland',
    'de-DE': 'Niederlande',
    'en-AE': 'Netherlands',
    'en-AU': 'Netherlands',
    'en-CA': 'Netherlands',
    'en-GB': 'Netherlands',
    'en-IN': 'Netherlands',
    'en-NG': 'Netherlands',
    'en-SG': 'Netherlands',
    'en-US': 'Netherlands',
    'en-ZA': 'Netherlands',
    'es-CL': 'Países Bajos',
    'es-CO': 'Países Bajos',
    'es-ES': 'Países Bajos',
    'es-MX': 'Países Bajos',
    'es-US': 'Países Bajos',
    'fr-BE': 'Pays-Bas',
    'fr-CA': 'Pays-Bas',
    'fr-FR': 'Pays-Bas',
    'he-IL': 'הולנד',
    'hi-IN': 'नीदरलैंड',
    'it-IT': 'Paesi Bassi',
    'ja-JP': 'オランダ',
    'kn-IN': 'ನೆದರ್ಲ್ಯಾಂಡ್ಸ್',
    'ko-KR': '네덜란드',
    'ml-IN': 'നെതർലാൻഡ്‌സ്',
    'mr-IN': 'नेदरलँड्स',
    'nl-BE': 'Nederland',
    'nl-NL': 'Nederland',
    'pl-PL': 'Holandia',
    'pt-BR': 'Países Baixos',
    'pt-PT': 'Países Baixos',
    'sv-SE': 'Nederländerna',
    'ta-IN': 'நெதர்லாந்து',
    'te-IN': 'నెదర్లాండ్స్‌',
    'tr-TR': 'Hollanda.',
    'zh-CN': '荷兰',
    'zh-TW': '荷蘭',
  },
  'region-selector-poland': {
    'ar-AE': 'بولندا',
    'bn-IN': 'পোল্যান্ড',
    'cs-CZ': 'Polsko',
    'da-DK': 'Polen',
    'de-DE': 'Polen',
    'en-AE': 'Poland',
    'en-AU': 'Poland',
    'en-CA': 'Poland',
    'en-GB': 'Poland',
    'en-IN': 'Poland',
    'en-NG': 'Poland',
    'en-SG': 'Poland',
    'en-US': 'Poland',
    'en-ZA': 'Poland',
    'es-CL': 'Polonia',
    'es-CO': 'Polonia',
    'es-ES': 'Polonia',
    'es-MX': 'Polonia',
    'es-US': 'Polonia',
    'fr-BE': 'Pologne',
    'fr-CA': 'Pologne',
    'fr-FR': 'Pologne',
    'he-IL': 'פולין',
    'hi-IN': 'पोलैंड',
    'it-IT': 'Polonia',
    'ja-JP': 'ポーランド',
    'kn-IN': 'ಪೋಲೆಂಡ್',
    'ko-KR': '폴란드',
    'ml-IN': 'പോളണ്ട്',
    'mr-IN': 'पोलंड',
    'nl-BE': 'Polen',
    'nl-NL': 'Polen',
    'pl-PL': 'Polska',
    'pt-BR': 'Polônia',
    'pt-PT': 'Polónia',
    'sv-SE': 'Polen',
    'ta-IN': 'போலந்து',
    'te-IN': 'పోలాండ్',
    'tr-TR': 'Polonya.',
    'zh-CN': '波兰',
    'zh-TW': '波蘭',
  },
  'region-selector-spain': {
    'ar-AE': 'إسبانيا',
    'bn-IN': 'স্পেন',
    'cs-CZ': 'Španělsko',
    'da-DK': 'Spanien',
    'de-DE': 'Spanien',
    'en-AE': 'Spain',
    'en-AU': 'Spain',
    'en-CA': 'Spain',
    'en-GB': 'Spain',
    'en-IN': 'Spain',
    'en-NG': 'Spain',
    'en-SG': 'Spain',
    'en-US': 'Spain',
    'en-ZA': 'Spain',
    'es-CL': 'España',
    'es-CO': 'España',
    'es-ES': 'España',
    'es-MX': 'España',
    'es-US': 'España',
    'fr-BE': 'Espagne',
    'fr-CA': 'Espagne',
    'fr-FR': 'Espagne',
    'he-IL': 'ספרד',
    'hi-IN': 'स्पेन',
    'it-IT': 'Spagna',
    'ja-JP': 'スペイン',
    'kn-IN': 'ಸ್ಪೇನ್',
    'ko-KR': '스페인',
    'ml-IN': 'സ്പെയിൻ',
    'mr-IN': 'स्पेन',
    'nl-BE': 'Spanje',
    'nl-NL': 'Spanje',
    'pl-PL': 'Hiszpania',
    'pt-BR': 'Espanha',
    'pt-PT': 'Espanha',
    'sv-SE': 'Spanien',
    'ta-IN': 'ஸ்பெயின்',
    'te-IN': 'స్పెయిన్',
    'tr-TR': 'İspanya.',
    'zh-CN': '西班牙',
    'zh-TW': '西班牙',
  },
  'region-selector-sweden': {
    'ar-AE': 'السويد',
    'bn-IN': 'সুইডেন',
    'cs-CZ': 'Švédsko',
    'da-DK': 'Sverige',
    'de-DE': 'Schweden',
    'en-AE': 'Sweden',
    'en-AU': 'Sweden',
    'en-CA': 'Sweden',
    'en-GB': 'Sweden',
    'en-IN': 'Sweden',
    'en-NG': 'Sweden',
    'en-SG': 'Sweden',
    'en-US': 'Sweden',
    'en-ZA': 'Sweden',
    'es-CL': 'Suecia',
    'es-CO': 'Suecia',
    'es-ES': 'Suecia',
    'es-MX': 'Suecia',
    'es-US': 'Suecia',
    'fr-BE': 'Suède',
    'fr-CA': 'Suède',
    'fr-FR': 'Suède',
    'he-IL': 'שוודיה',
    'hi-IN': 'स्वीडन',
    'it-IT': 'Svezia',
    'ja-JP': 'スウェーデン',
    'kn-IN': 'ಸ್ವೀಡನ್',
    'ko-KR': '스웨덴',
    'ml-IN': 'സ്വീഡൻ',
    'mr-IN': 'स्वीडन',
    'nl-BE': 'Zweden',
    'nl-NL': 'Zweden',
    'pl-PL': 'Szwecja',
    'pt-BR': 'Suécia',
    'pt-PT': 'Suécia',
    'sv-SE': 'Sverige',
    'ta-IN': 'ஸ்வீடன்',
    'te-IN': 'స్వీడన్',
    'tr-TR': 'İsveç.',
    'zh-CN': '瑞典',
    'zh-TW': '瑞典',
  },
  'region-selector-turkey': {
    'ar-AE': 'تركيا',
    'bn-IN': 'তুর্কি',
    'cs-CZ': 'Turecko',
    'da-DK': 'Tyrkiet',
    'de-DE': 'Türkei',
    'en-AE': 'Turkey',
    'en-AU': 'Turkey',
    'en-CA': 'Turkey',
    'en-GB': 'Turkey',
    'en-IN': 'Turkey',
    'en-NG': 'Turkey',
    'en-SG': 'Turkey',
    'en-US': 'Turkey',
    'en-ZA': 'Turkey',
    'es-CL': 'Turquía',
    'es-CO': 'Turquía',
    'es-ES': 'Turquía',
    'es-MX': 'Turquía',
    'es-US': 'Turquía',
    'fr-BE': 'Turquie',
    'fr-CA': 'Dinde',
    'fr-FR': 'Turquie',
    'he-IL': 'טורקיה',
    'hi-IN': 'तुर्की',
    'it-IT': 'Turchia',
    'ja-JP': 'トルコ',
    'kn-IN': 'ಟರ್ಕಿ',
    'ko-KR': '튀르키예',
    'ml-IN': 'തുര്‍ക്കി',
    'mr-IN': 'तुर्की',
    'nl-BE': 'Turkije',
    'nl-NL': 'Turkije',
    'pl-PL': 'Turcja',
    'pt-BR': 'Turquia',
    'pt-PT': 'Turquia',
    'sv-SE': 'Turkiet',
    'ta-IN': 'துருக்கி',
    'te-IN': 'టర్కీ',
    'tr-TR': 'Türkiye.',
    'zh-CN': '土耳其',
    'zh-TW': '土耳其',
  },
  'region-selector-united-kingdom': {
    'ar-AE': 'المملكة المتحدة',
    'bn-IN': 'যুক্তরাজ্য',
    'cs-CZ': 'Spojené království',
    'da-DK': 'Storbritannien',
    'de-DE': 'Vereinigtes Königreich',
    'en-AE': 'United Kingdom',
    'en-AU': 'United Kingdom',
    'en-CA': 'United Kingdom',
    'en-GB': 'United Kingdom',
    'en-IN': 'United Kingdom',
    'en-NG': 'United Kingdom',
    'en-SG': 'United Kingdom',
    'en-US': 'United Kingdom',
    'en-ZA': 'United Kingdom',
    'es-CL': 'Reino Unido',
    'es-CO': 'Reino Unido',
    'es-ES': 'Reino Unido',
    'es-MX': 'Reino Unido',
    'es-US': 'Reino Unido',
    'fr-BE': 'Royaume-Uni',
    'fr-CA': 'Royaume-Uni',
    'fr-FR': 'Royaume-Uni',
    'he-IL': 'בריטניה',
    'hi-IN': 'यूनाइटेड किंगडम',
    'it-IT': 'Regno Unito',
    'ja-JP': '英国',
    'kn-IN': 'ಯುನೈಟೆಡ್ ಕಿಂಗ್ಡಮ್',
    'ko-KR': '영국',
    'ml-IN': 'യുണൈറ്റഡ് കിംഗ്ഡം',
    'mr-IN': 'युनायटेड किंग्डम',
    'nl-BE': 'Verenigd Koninkrijk',
    'nl-NL': 'Verenigd Koninkrijk',
    'pl-PL': 'Wielka Brytania',
    'pt-BR': 'Reino Unido',
    'pt-PT': 'Reino Unido',
    'sv-SE': 'Storbritannien',
    'ta-IN': 'இங்கிலாந்து',
    'te-IN': 'యునైటెడ్ కింగ్‌డమ్',
    'tr-TR': 'Birleşik Krallık.',
    'zh-CN': '英国',
    'zh-TW': '英國',
  },
  'region-selector-middle-east-and-north-africa': {
    'ar-AE': 'الشرق الأوسط و شمال أفريقيا',
    'bn-IN': 'মধ্য-পূর্ব ও উত্তর আফ্রিকা',
    'cs-CZ': 'Blízký východ a severní Afrika',
    'da-DK': 'Mellemøsten og Nordafrika',
    'de-DE': 'Naher Osten und Nordafrika',
    'en-AE': 'Middle East and North Africa',
    'en-AU': 'Middle East and North Africa',
    'en-CA': 'Middle East and North Africa',
    'en-GB': 'Middle East and North Africa',
    'en-IN': 'Middle East and North Africa',
    'en-NG': 'Middle-East and North Africa',
    'en-SG': 'Middle East and North Africa',
    'en-US': 'Middle-east and North Africa',
    'en-ZA': 'Middle East and North Africa',
    'es-CL': 'Medio Oriente y Norte de África',
    'es-CO': 'Medio Oriente y Norte de África',
    'es-ES': 'Oriente Medio y África del Norte',
    'es-MX': 'Medio Oriente y Norte de África',
    'es-US': 'Medio Oriente y África del Norte',
    'fr-BE': 'Moyen-Orient et Afrique du Nord',
    'fr-CA': 'Moyen-Orient et Afrique du Nord',
    'fr-FR': 'Moyen-Orient et Afrique du Nord',
    'he-IL': 'המזרח התיכון וצפון אפריקה',
    'hi-IN': 'मध्य-पूर्व और उत्तरी अफ़्रीका',
    'it-IT': 'Medio Oriente e Nord Africa',
    'ja-JP': '中東および北アフリカ',
    'kn-IN': 'ಮಧ್ಯ-ಪ್ರಾಚ್ಯ ಮತ್ತು ಉತ್ತರ ಆಫ್ರಿಕಾ',
    'ko-KR': '중동 및 북아프리카',
    'ml-IN': 'മിഡിൽ ഈസ്റ്റ്, വടക്കേ ആഫ്രിക്ക',
    'mr-IN': 'मध्य-पूर्व आणि उत्तर आफ्रिका',
    'nl-BE': 'Midden-Oosten en Noord-Afrika',
    'nl-NL': 'Midden-Oosten en Noord-Afrika',
    'pl-PL': 'Bliski Wschód i Afryka Północna',
    'pt-BR': 'Oriente Médio e África do Norte',
    'pt-PT': 'Médio Oriente e Norte de África',
    'sv-SE': 'Mellanöstern och Nordafrika',
    'ta-IN': 'மத்திய கிழக்கு மற்றும் வட ஆப்பிரிக்க நாடுகள்',
    'te-IN': 'మధ్య తూర్పు మరియు ఉత్తర ఆఫ్రికా',
    'tr-TR': 'Orta Doğu ve Kuzey Afrika.',
    'zh-CN': '中东和北非',
    'zh-TW': '中東和北非',
  },
  'region-selector-egypt': {
    'ar-AE': 'مصر',
    'bn-IN': 'মিশর',
    'cs-CZ': 'Egypt',
    'da-DK': 'Ægypten',
    'de-DE': 'Ägypten',
    'en-AE': 'Egypt',
    'en-AU': 'Egypt',
    'en-CA': 'Egypt',
    'en-GB': 'Egypt',
    'en-IN': 'Egypt',
    'en-NG': 'Egypt',
    'en-SG': 'Egypt',
    'en-US': 'Egypt',
    'en-ZA': 'Egypt',
    'es-CL': 'Egipto',
    'es-CO': 'Egipto',
    'es-ES': 'Egipto',
    'es-MX': 'Egipto',
    'es-US': 'Egipto',
    'fr-BE': 'Égypte',
    'fr-CA': 'Égypte',
    'fr-FR': 'Égypte',
    'he-IL': 'מצרים',
    'hi-IN': 'मिस्र',
    'it-IT': 'Egitto',
    'ja-JP': 'エジプト',
    'kn-IN': 'ಈಜಿಪ್ಟ್',
    'ko-KR': '이집트',
    'ml-IN': 'ഈജിപ്‌ത്',
    'mr-IN': 'इजिप्त',
    'nl-BE': 'Egypte',
    'nl-NL': 'Egypte',
    'pl-PL': 'Egipt',
    'pt-BR': 'Egito',
    'pt-PT': 'Egito',
    'sv-SE': 'Egypten',
    'ta-IN': 'எகிப்து',
    'te-IN': 'ఈజిప్ట్',
    'tr-TR': 'Mısır.',
    'zh-CN': '埃及',
    'zh-TW': '埃及',
  },
  'region-selector-saudi-arabia': {
    'ar-AE': 'المملكة العربية السعودية',
    'bn-IN': 'সৌদি আরব',
    'cs-CZ': 'Saúdská Arábie',
    'da-DK': 'Saudi-Arabien',
    'de-DE': 'Saudi-Arabien',
    'en-AE': 'Saudi Arabia',
    'en-AU': 'Saudi Arabia',
    'en-CA': 'Saudi Arabia',
    'en-GB': 'Saudi Arabia',
    'en-IN': 'Saudi Arabia',
    'en-NG': 'Saudi Arabia',
    'en-SG': 'Saudi Arabia',
    'en-US': 'Saudi Arabia',
    'en-ZA': 'Saudi Arabia',
    'es-CL': 'Arabia Saudita',
    'es-CO': 'Arabia Saudita',
    'es-ES': 'Arabia Saudí',
    'es-MX': 'Arabia Saudita',
    'es-US': 'Arabia Saudita',
    'fr-BE': 'Arabie saoudite',
    'fr-CA': 'Arabie saoudite',
    'fr-FR': 'Arabie saoudite',
    'he-IL': 'ערב הסעודית',
    'hi-IN': 'सऊदी अरब',
    'it-IT': 'Arabia Saudita',
    'ja-JP': 'サウジアラビア',
    'kn-IN': 'ಸೌದಿ ಅರೇಬಿಯಾ',
    'ko-KR': '사우디아라비아',
    'ml-IN': 'സൗദി അറേബ്യ',
    'mr-IN': 'सौदी अरेबिया',
    'nl-BE': 'Saoedi-Arabië',
    'nl-NL': 'Saoedi-Arabië',
    'pl-PL': 'Arabia Saudyjska',
    'pt-BR': 'Arábia Saudita',
    'pt-PT': 'Arábia Saudita',
    'sv-SE': 'Saudiarabien',
    'ta-IN': 'சவுதி அரேபியா',
    'te-IN': 'సౌదీ అరేబియా',
    'tr-TR': 'Suudi Arabistan.',
    'zh-CN': '沙特阿拉伯',
    'zh-TW': '沙烏地阿拉伯',
  },
  'region-selector-united-arab-emirates': {
    'ar-AE': 'الإمارات العربية المتحدة',
    'bn-IN': 'সংযুক্ত আরব আমিরাত',
    'cs-CZ': 'Spojené arabské emiráty',
    'da-DK': 'De Forenede Arabiske Emirater',
    'de-DE': 'Vereinigte Arabische Emirate',
    'en-AE': 'United Arab Emirates',
    'en-AU': 'United Arab Emirates',
    'en-CA': 'United Arab Emirates',
    'en-GB': 'United Arab Emirates',
    'en-IN': 'United Arab Emirates',
    'en-NG': 'United Arab Emirates',
    'en-SG': 'United Arab Emirates',
    'en-US': 'United Arab Emirates',
    'en-ZA': 'United Arab Emirates',
    'es-CL': 'Emiratos Árabes Unidos',
    'es-CO': 'Emiratos Árabes Unidos',
    'es-ES': 'Emiratos Árabes Unidos',
    'es-MX': 'Emiratos Árabes Unidos',
    'es-US': 'Emiratos Árabes Unidos',
    'fr-BE': 'Émirats arabes unis',
    'fr-CA': 'Émirats arabes unis',
    'fr-FR': 'Émirats arabes unis',
    'he-IL': 'איחוד האמירויות הערביות',
    'hi-IN': 'संयुक्त अरब अमीरात',
    'it-IT': 'Emirati Arabi Uniti',
    'ja-JP': 'アラブ首長国連邦',
    'kn-IN': 'ಯುನೈಟೆಡ್‌ ಅರಬ್ ಎಮಿರೇಟ್ಸ್',
    'ko-KR': '아랍에미리트',
    'ml-IN': 'യുണൈറ്റഡ് അറബ് എമിറേറ്റ്സ്',
    'mr-IN': 'संयुक्त अरब अमिराती',
    'nl-BE': 'Verenigde Arabische Emiraten',
    'nl-NL': 'Verenigde Arabische Emiraten',
    'pl-PL': 'Zjednoczone Emiraty Arabskie',
    'pt-BR': 'Emirados Árabes Unidos',
    'pt-PT': 'Emirados Árabes Unidos',
    'sv-SE': 'Förenade Arabemiraten',
    'ta-IN': 'ஐக்கிய அரபு நாடுகள்',
    'te-IN': 'యునైటెడ్ అరబ్ ఎమిరేట్స్',
    'tr-TR': 'Birleşik Arap Emirlikleri.',
    'zh-CN': '阿联酋',
    'zh-TW': '阿拉伯聯合大公國',
  },
};

export default katTranslator(strings);
